export default "__VITE_ASSET__72be1381__"